module.exports = __webpack_public_path__ + "img/55.a04dd88c.jpg";